import i18n from 'i18n';
import {SidebarMenuSections} from './sidebarMenu';

export const SidebarMenuSectionLabels: Partial<Record<SidebarMenuSections, string>> = {
    [SidebarMenuSections.Insights]: i18n.t('sidebar_insights.text'),
    [SidebarMenuSections.Discover]: i18n.t('sidebar_discover.text'),
    [SidebarMenuSections.Tasks]: i18n.t('sidebar_tasks.text'),
    [SidebarMenuSections.Conversations]: i18n.t('sidebar_conversations.text'),
    [SidebarMenuSections.Customers]: i18n.t('sidebar_customers.text'),
    [SidebarMenuSections.Agents]: i18n.t('sidebar_agents.text', 'Agents'),
    [SidebarMenuSections.Teams]: i18n.t('sidebar_teams.text', 'Teams'),
    [SidebarMenuSections.Admin]: i18n.t('sidebar_admin.text'),
    [SidebarMenuSections.Reports]: i18n.t('sidebar_reports.text'),
    [SidebarMenuSections.Stories]: i18n.t('sidebar_stories.text'),
    [SidebarMenuSections.Settings]: i18n.t('sidebar_settings.text'),
};
